import PromptTemplateDataTable from '../components/PromptTemplateDataTable';

export default function WordGroupCategoryPrompts() {
  return <PromptTemplateDataTable templateType="word_group_category" />;
}
